module.exports = __webpack_public_path__ + "media/images/pc/top/icon-location-a358948714e13548277d2e9b533c8bbd.svg";